import dayjs from 'dayjs';

/** The column's observed span, captioned under a calendar. Renders NOTHING when either end is unknown —
 *  a half-known range presented as a range is a measurement we did not make. */
export function ObservedRange({ min, max }: { min?: string; max?: string }) {
  if (!min || !max) return null;
  return (
    <p data-slot="observed-range" className="px-3 pb-2 text-xs text-muted-foreground">
      Data spans {dayjs(min).format('MMM D, YYYY')} – {dayjs(max).format('MMM D, YYYY')}
    </p>
  );
}
